export default [{
  path: '/importacoes-dados',
  component: () => import('@/views/Index'),
  children: [
    {
      name: 'Importações de Dados',
      path: '',
      redirect: { name: 'Importações de Dados Hexa' },
      meta: {
        requiresAuth: true,
        admin: false,
        breadcrumb: [
          { name: 'Dados', path: '/dados' },
          { name: 'Importações de Dados' }
        ]
      }
    },
    {
      name: 'Importações de Dados Cliente',
      path: 'cliente',
      redirect: { name: 'Importações de Dados Hexa' },
      meta: {
        requiresAuth: true,
        admin: false,
        breadcrumb: [
          { name: 'Dados', path: '/dados'},
          { name: 'Importações de Dados' }
        ]
      }
    },
    {
      name: 'Importações de Dados Adicionar',
      path: 'cliente/add',
      redirect: { name: 'Importações de Dados Hexa Adicionar' },
      meta: {
        requiresAuth: true,
        admin: false,
        breadcrumb: [
          { name: 'Dados', path: '/dados'},
          { name: 'Importações de Dados', path: '/importacoes-dados/cliente' },
          { name: 'Adicionar' }
        ]
      }
    },
    {
      name: 'Importações de Dados Hexa',
      path: 'administracao',
      component: () => import('@/views/importacoesDados/administracao/Index.vue'),
      meta: {
        requiresAuth: true,
        admin: false,
        breadcrumb: [
          { name: 'Dados', path: '/dados'},
          { name: 'Importações de Dados' }
        ]
      }
    },
    {
      name: 'Importações de Dados Hexa Adicionar',
      path: 'administracao/add',
      component: () => import('@/views/importacoesDados/administracao/Add.vue'),
      meta: {
        requiresAuth: true,
        admin: false,
        breadcrumb: [
          { name: 'Dados', path: '/dados'},
          { name: 'Importações de Dados', path: '/importacoes-dados/administracao' },
          { name: 'Adicionar' }
        ]
      }
    }
  ]
}]  
